export default __webpack_public_path__ + "static/media/pokemon-song.e5d98e88.mp3";